import React from 'react';
import ItemSalesTable from '../components/ItemSales/ItemSalesTable.jsx';

export default function ItemSaleLanding() {
    return (
        <div>
            {/* Add the Date filter -- remove the locations */}

            {/* Bring in the data grid */}
            <ItemSalesTable dateFilter={null} />
        </div>
    );
};
